import * as React from 'react'

import Menu from '@components/menu'
import ModalContext, { useModals } from '@components/modal-context'
import SEO, { ISeoProps } from '@components/seo'

const LazyFooter = React.lazy(() => import('@components/footer'))
const LazyContactUsForm = React.lazy(
  () => import('@components/contact-us-form'),
)

import '../scss/style.scss'

interface MainLayoutProps {
  seoProps: ISeoProps
  logoStyle?: 'light' | 'dark' | 'white'
  footerWrapperClass?: string
  bodyWrapperClass?: string
  fixedMenu?: boolean
  children: React.ReactNode
}

const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  seoProps,
  logoStyle,
  bodyWrapperClass,
  footerWrapperClass,
}) => {
  const modalContext = useModals()

  return (
    <ModalContext.Provider value={modalContext}>
      <div className={bodyWrapperClass}>
        <SEO {...seoProps} />
        <Menu logoStyle={logoStyle} />
        <main>{children}</main>
        <React.Suspense fallback={null}>
          <div className={footerWrapperClass || ''}>
            <LazyFooter />
          </div>
        </React.Suspense>
        <React.Suspense fallback={null}>
          <LazyContactUsForm isOpen={modalContext['contact-us'].isOpen} />
        </React.Suspense>
      </div>
    </ModalContext.Provider>
  )
}

export default MainLayout
